var render = function render(){var _vm=this,_c=_vm._self._c;return _c('user-list-filter',{attrs:{"label":"Created By","icon":"mdi-account-outline","filter":_vm.filters.created_by,"filter-function":_vm._updateFilters}})
}
var staticRenderFns = []

export { render, staticRenderFns }